import React from 'react';

export default function ResultsCard({ loan }) {
    if (loan.servicer == "DMI") {
        return (
            <div className="card card--secondary">
                <h2>Previous Loan Number</h2>
                <div className="mb-4">
                    <h3><strong>Loan Number: {loan.servicingLoanNumber}</strong></h3>
                    <p>Your loan details are ready. Let’s proceed to manage your account.</p>
                </div>
                <p>
                    <strong>Call Us:</strong> <a href="tel:8772300466">(877) 230-0466</a><br />
                    <strong>Send Payments to:</strong><br />
                    P.O. Box 606592<br />
                    Dallas, TX 75266-0592
                </p>
                <h4>
                    PLEASE INCLUDE YOUR LOAN NUMBER ON ALL PAYMENTS
                </h4>
                <a href="https://www.yourmortgageonline.com/" target="_blank" className="btn btn--secondary">Manage Loan</a>
            </div>
        )
    }
    else {
        return (
            <>
                <div className="card">
                    <h2>Loan Number Confirmed</h2>
                    <div className="mb-4">
                        <h3><strong>Loan Number: {loan.servicingLoanNumber}</strong></h3>
                        <p>Your loan details are ready. Let’s proceed to manage your account.</p>
                    </div>
                    <p>
                        <strong>Call Us:</strong> <a href="tel:8775579042">(877) 557-9042</a><br/>
                        <strong>Send Payments to:</strong><br />
                        P.O. Box 660155<br />
                        Dallas, TX 75266-0155
                    </p>
                    <h4>
                        PLEASE INCLUDE YOUR LOAN NUMBER ON ALL PAYMENTS
                    </h4>
                    <a href="https://servicing.lhfs.com/" target="_blank" className="btn btn--primary">Manage Loan</a>
                </div>
            </>
        )
    }
}